const COOKIE_AUTH_APP_CODES = ['rh_protegido', 'dr_protegido'];

const NGROK_HOST_RE = /ngrok/i;

export function withNgrokSkipBrowserWarning(config) {
  const url = config.url || '';
  const headers = { ...(config.headers || {}) };
  if (url && NGROK_HOST_RE.test(url)) {
    headers['ngrok-skip-browser-warning'] = 'true';
  }
  return { ...config, headers };
}

export function isCookieAuth(appCode) {
  return COOKIE_AUTH_APP_CODES.includes(appCode);
}

function isAuthOrSecurityApiUrl(url) {
  if (url == null || typeof url !== 'string') return false;
  const authBase = process.env.VUE_APP_AUTH_SERVICE_URL || '';
  const secBase = process.env.VUE_APP_SECURITY_SERVICE_URL || '';
  return (
    (authBase.length > 0 && url.indexOf(authBase) === 0) ||
    (secBase.length > 0 && url.indexOf(secBase) === 0)
  );
}

const SENSITIVE_TOKEN_SECURITY_KEYS = [
  'access_token',
  'tinnyToken',
  'refresh_token',
  'id_token',
  'token',
];

export function sanitizeSessionForPersistence(session, appCode) {
  if (!isCookieAuth(appCode) || !session) {
    return session;
  }
  try {
    const clone = JSON.parse(JSON.stringify(session));
    if (clone.tokenSecurityService && typeof clone.tokenSecurityService === 'object') {
      const ts = { ...clone.tokenSecurityService };
      SENSITIVE_TOKEN_SECURITY_KEYS.forEach((k) => {
        delete ts[k];
      });
      const rem = Object.keys(ts).length;
      clone.tokenSecurityService = rem ? ts : { cookieAuth: true };
    }
    if (clone.loggedBy && typeof clone.loggedBy === 'object') {
      const lb = { ...clone.loggedBy };
      delete lb.token;
      delete lb.tinnyToken;
      clone.loggedBy = Object.keys(lb).length ? lb : undefined;
    }
    return clone;
  } catch (e) {
    return session;
  }
}

export function applyAuthAccount(config, appCode) {
  const useCookies =
    isCookieAuth(appCode) || isAuthOrSecurityApiUrl(config.url);
  return withNgrokSkipBrowserWarning({
    ...config,
    headers: { ...(config.headers || {}) },
    withCredentials: useCookies,
  });
}
